/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGroupGlasses = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M23 14.197v6.053a2.75 2.75 0 1 1-5.487-.245.027.027 0 0 0-.006-.003L17.5 20c-.002 0-.004 0-.007.002l-.007.003c.007.08.014.162.014.245a2.75 2.75 0 1 1-5.5 0v-6.053l1.168-1.752 1.664 1.11L14 14.803v2.803a2.737 2.737 0 0 1 2.596.61 2.007 2.007 0 0 1 1.807 0 2.738 2.738 0 0 1 2.597-.61v-2.803l-.832-1.248 1.664-1.11zM14.75 19.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zm5.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zM9 14c.346 0 .68.013 1 .037v2.009C9.69 16.017 9.358 16 9 16c-4.1 0-5 2.7-5 5v1H2v-1c0-4.4 2.6-7 7-7z" />
        <path d="M16 4c2.8 0 5 2.2 5 5s-2.2 5-5 5v-2c1.7 0 3-1.3 3-3s-1.3-3-3-3zM9 2c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5zm0 2C7.3 4 6 5.3 6 7s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z" />
      </g>
    </g>
  </Icon>
);
export { SvgGroupGlasses as GroupGlasses };
